@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="true"></loading>
} @else {
    @if (authSession) {
        <div class="flex flex-col gap-2 sm:pt-4">
            <div class="flex flex-col gap-2 p-2">
                <div class="font-bold border-slate-300 border-b">
                    Security Settings
                </div>
                <div class="flex flex-col gap-2 text-sm">
                    <user-email-change [authSession]="authSession"></user-email-change>
                    <user-password-change [authSession]="authSession"></user-password-change>
                </div>
            </div>
        </div>
    } @else {
        <unauthorized></unauthorized>
    }
}